/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable function-paren-newline */
import { Component, Host, h, Prop, Watch } from '@stencil/core';
import { deepParse } from '../../services';
import { Disclaimer } from './rcm-disclaimer.types';

@Component({
  tag: 'rcm-disclaimer',
  styleUrl: 'rcm-disclaimer.scss',
  shadow: true,
})
export class RcmDisclaimer {
  @Prop({ mutable: true }) disclaimers: string | Disclaimer[];

  @Prop() full = false;

  @Prop() big = false;

  @Prop() inline = false;

  @Watch('disclaimers')
  componentWillLoad() {
    if (typeof this.disclaimers === 'string') {
      const parsedDisclaimers = deepParse(this.disclaimers);

      this.disclaimers = parsedDisclaimers.map((item) =>
        // eslint-disable-next-line no-underscore-dangle
        ({ id: item.content?._uid, text: item.content?.text }),
      );
    }
  }

  render() {
    return (
      <Host>
        <rcm-container fullWidth={this.full}>
          {Array.isArray(this.disclaimers) &&
            this.disclaimers?.map(({ id, text, bold }) => (
              <p
                class={`legal-text ${bold ? 'legal-text--bold' : ''} ${this.big ? 'legal-text--big' : ''} ${this.inline ? 'legal-text--inline' : ''}`}
                key={id}
              >
                {`${text} `}
              </p>
            ))}
        </rcm-container>
      </Host>
    );
  }
}
